"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniSearch = void 0;
var tslib_1 = require("tslib");
var image_button_1 = require("../../components/button/image.button");
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var omni_search_style_1 = require("./omni.search.style");
(0, theme_1.addStyles)(omni_search_style_1.Style);
var OmniSearch = /** @class */ (function (_super) {
    tslib_1.__extends(OmniSearch, _super);
    function OmniSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OmniSearch.prototype, "nodes", {
        get: function () {
            var _this = this;
            var cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
                className: omni_search_style_1.CSS.clear,
                onclick: function () { return services_1.Services.Search.reset(); }
            });
            var icon = services_1.Services.Search.inFlight ?
                spinner_1.Spinner.view(omni_search_style_1.CSS.icon) :
                icon_1.Icon.view(icons_1.MaterialIcon.SEARCH, { className: omni_search_style_1.CSS.icon });
            return (0, mithril_1.m)('div', { className: omni_search_style_1.CSS.container }, [
                icon,
                (0, mithril_1.m)('input', {
                    className: omni_search_style_1.CSS.input,
                    type: 'text',
                    placeholder: (0, index_1.Translate)(index_1.T.SEARCH),
                    value: services_1.Services.Search.inputfilterState.filter,
                    oninput: function (e) { return _this.onChange(e); }
                }),
                services_1.Services.Search.inputfilterState.hasFilter() ? cancelButton : null
            ]);
        },
        enumerable: false,
        configurable: true
    });
    OmniSearch.prototype.onChange = function (e) {
        services_1.Services.Search.inputfilterState.setFilter(e.target.value);
    };
    return OmniSearch;
}(mithril_component_1.IMithrilComponent));
exports.OmniSearch = OmniSearch;
//# sourceMappingURL=omni.search.js.map